import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { TileLayer } from "react-leaflet";

import LeafletMap from "components/LeafletMap";

import NonMovingCarsLayers from "scenes/NonMovingCars/components/NonMovingCarsLayers";
import NonMovingCarsActioner from "services/nonMovingCars/actioner";
import MapActioner from "services/map/actioner";
import MapUtils from "services/map/utils";
import MapConfig from "services/map/MapConfig";

function MapComponent({
  center,
  initFloorsData,
  maxZoom,
  minZoom,
  onRecenter,
  radius,
  retrieveNonMovingCars,
  setConfigParam,
  tilesUrl,
  zoom,
}) {
  const [leafletMap, setLeafletMap] = useState();

  useEffect(() => {
    initFloorsData();
  }, [initFloorsData, onRecenter]);

  useEffect(() => {
    if (leafletMap) {
      onRecenter(leafletMap?.leafletElement);
    }
  }, [onRecenter, leafletMap]);

  function getMapRadius(map) {
    return MapUtils.getRadiusInMeters(
      map.getBounds().getNorthEast(),
      map.getCenter()
    );
  }

  function handleClosePopup() {
    return leafletMap?.leafletElement?.closePopup();
  }

  function handleZoomEnd(e) {
    const currentMap = e?.target;

    handleClosePopup();
    setConfigParam("currentRadius", getMapRadius(currentMap));
    setConfigParam("currentZoom", currentMap.getZoom());
  }

  function handleMoveEnd(e) {
    const currentMap = e?.target;

    handleClosePopup();
    setConfigParam("currentRadius", getMapRadius(currentMap));
    setConfigParam("currentPosition", currentMap.getCenter());
  }

  function handleOnLoad(e) {
    const currentMap = e?.target;
    setConfigParam("currentRadius", getMapRadius(currentMap._map));
    setConfigParam("currentPosition", currentMap._map.getCenter());

    if (!radius) {
      retrieveNonMovingCars();
    }
  }

  return (
    <LeafletMap
      preferCanvas
      style={{
        width: "100%",
        height: "100%",
      }}
      setMapRef={setLeafletMap}
      center={center}
      zoom={zoom}
      minZoom={minZoom}
      maxZoom={maxZoom}
      onZoomEnd={handleZoomEnd}
      onMoveEnd={handleMoveEnd}
    >
      <TileLayer url={MapConfig.defaultTileUrl} />
      <TileLayer
        url={tilesUrl}
        onLoad={handleOnLoad}
        minZoom={minZoom}
        maxZoom={maxZoom}
      />
      <NonMovingCarsLayers />
    </LeafletMap>
  );
}

Map.defaultProps = {};

Map.propTypes = {
  center: PropTypes.array.isRequired,
  zoom: PropTypes.number.isRequired,
  minZoom: PropTypes.number.isRequired,
  maxZoom: PropTypes.number.isRequired,
  tilesUrl: PropTypes.string,
};

const mapStateToProps = (state) => ({
  center: MapUtils.getCenter(state.Map),
  zoom: MapUtils.getZoom(state.Map),
  minZoom: MapUtils.getMinZoom(state.Map),
  maxZoom: MapUtils.getMaxZoom(state.Map),
  tilesUrl: MapUtils.getTilesUrl(state.Map),
  radius: state.GlobalFilters.radius,
});

const mapDispatchToProps = (dispatch) => ({
  setConfigParam: (key, value) =>
    dispatch(MapActioner.setConfigParam(key, value)),
  initFloorsData: () =>
    dispatch(MapActioner.initFloorsDataFromModule("non_moving_cars")),
  retrieveNonMovingCars: () =>
    dispatch(NonMovingCarsActioner.retrieveList("radius")),
});

const ConnectedMap = connect(mapStateToProps, mapDispatchToProps)(MapComponent);
export default ConnectedMap;
